import request from './request'

/**
 * 上传文章
 * 
 * @export
 * @param {any} data 
 * @returns 
 */
export function upLoadArtical(data){
    let url = "/api/Article/CreateOrUpdateArticleAsync";
    return request({
        url: url,
        method: 'post',
        dataType: 'json',
        data
    });
}
/**
 * 获取文章类型
 * 
 * @export
 * @returns 
 */
export function getArticalType(data){
    let url = "/api/DirectoryCategory/GetPageDirectoryAsync";
    return request({
        url: url,
        method: "post",
        dataType: "json",
        data
    });
}
/**
 * base64图片上传
 * 
 * @export
 * @param {any} data 
 * @returns 
 */
export function uploadBase64(data){
    let url = "/api/UpLoadFile/UpFileByBase64Async";
    return request({
        url: url,
        method: "post",
        dataType: "json",
        data
    });
}
 
//上传文件合并 {FileIdentifier: "",FileName: ""}
export function mergeFile(data){
    return request({
        url: "/api/UpLoadFile/UploadFinishAsync",
        method: "post",
        data
    })
}

//获取版权所有
export function getCprInfo(){
    return request({
        url: "/api/CopyrightInfo/GetCopyrightAllAsync",
        method: "get"
    })
}

//根据版权所有Id获取对应版权相关信息 {CopytrightAllId: ""}
export function getCprDetail(data){
    return request({
        url: "/api/CopyrightInfo/GetCopyrightInfosAsync",
        method: "get",
        params: data
    })
}

//上传图片素材
export function uploadePhoto(data){
    return request({
        url: "/api/File/CreateUpdateFileAsync",
        method: "post",
        data
    })
}

//普通文件上传FormData对象{File: "", FileExtension: ""}
export function uploadCommonFile(data){
    return request({
        url: "/api/UpLoadFile/UploadFileAsync",
        method: "post",
        data: data,
        headers: {
            "Content-Type": 'multipart/form-data'
        }
    })
}

//根据分类获取系统标签
export function getSystemLabels(data){
    return request({
        url: "/api/Label/GetBelongPageSystemLabelsAsync",
        method: "get",
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/shareApi.js